/**
 *
 * AuthModal
 *
 */

import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import Modal from '@material-ui/core/Modal';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { toast } from 'react-toastify';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import _get from 'lodash/get';
import {
  makeSelectAuth,
  makeSelectAuthModal,
  makeSelectAuthModalAction,
  makeSelectError,
  makeSelectProcessing,
  makeSelectProfile,
  makeSelectStoredItem,
} from 'containers/Auth/selectors';
import {
  signUp,
  setAuthModalState,
  storeItemForSignIn,
} from 'containers/Auth/actions';
import LoadingOverlay from 'components/LoadingOverlay';
import Mixpanel from 'utils/mixpanelService';
import ModalContent from './ModalContent';

const stateSelector = createStructuredSelector({
  action: makeSelectAuthModalAction(),
  auth: makeSelectAuth(),
  clientDetails: makeSelectClientDetails(),
  error: makeSelectError(),
  modal: makeSelectAuthModal(),
  processing: makeSelectProcessing(),
  profile: makeSelectProfile(),
  storedItem: makeSelectStoredItem(),
});

const AuthModal = () => {
  const dispatch = useDispatch();
  const {
    action,
    auth,
    clientDetails,
    error,
    modal,
    processing,
    profile,
    storedItem,
  } = useSelector(stateSelector);

  useEffect(() => {
    if (modal.show)
      Mixpanel.track('Authentication Modal - Opened', {
        trigger: storedItem.type,
      });
  }, [modal, storedItem]);

  useEffect(() => {
    if (
      modal.show &&
      auth.isLoaded &&
      !auth.isEmpty &&
      profile.isLoaded &&
      !profile.isEmpty
    ) {
      const isSignUp =
        Date.now() - auth.createdAt < 5 * 60 * 1000 &&
        !_get(profile, 'signUpCompleted');

      if (
        !isSignUp ||
        _get(clientDetails, 'metadata.hideSubscription') ||
        auth.providerData[0].providerId === 'password'
      ) {
        dispatch(setAuthModalState({ show: false, type: '' }));
      }
    }
  }, [auth, clientDetails, dispatch, modal, profile]);

  useEffect(() => {
    if (modal.show && !_isEmpty(error)) {
      toast(error.message, { type: 'error' });
    }
  }, [error, modal]);

  const handleSignUp = ({ data, provider, subscription }) => {
    if (provider === null) {
      dispatch(
        signUp({
          data,
          provider: null,
          subscription,
        }),
      );
    } else {
      dispatch(
        signUp({
          provider,
          subscription,
        }),
      );
    }
  };

  const handleClose = () => {
    dispatch(storeItemForSignIn({}));
    dispatch(setAuthModalState({ show: false, type: '' }));
  };

  return (
    <>
      <Modal open={modal.show}>
        <div>
          <ModalContent
            action={action}
            profile={profile}
            storedItemPayload={storedItem.payload}
            type={modal.type}
            onClose={handleClose}
            onSignUp={handleSignUp}
          />
        </div>
      </Modal>
      <LoadingOverlay show={processing} />
    </>
  );
};

export default AuthModal;
